export enum  CommitViewFormat {
  Vertical = 'vertical',
  SideBySide = 'side-by-side'
}
